import { Mapper } from '../services/mapper.service'

import { ClareSaleGroup } from './clare-sale-group'
import { MappableModel } from './mappable-model'
import { MembershipDefinition } from './membership-definition'

export class MembershipInvite extends MappableModel {
  public id: string
  public boss_organization_id: number
  public membership_id: string
  public membership_definition_id: string
  public persona_id: number
  public affiliation_organization_id: number
  public status: string
  public created_by_user_id: number
  public expires_at: Date | null
  public created_at: Date | null
  public updated_at: Date | null
  public membership_definition: MembershipDefinition
  public clare_sale_group: ClareSaleGroup

  public deserialize(): void {
    this.membership_definition = Mapper.as<MembershipDefinition>(this.membership_definition, MembershipDefinition)
    if (this.clare_sale_group) this.clare_sale_group = Mapper.as<ClareSaleGroup>(this.clare_sale_group, ClareSaleGroup)
    this.expires_at = this.expires_at ? new Date(this.expires_at) : null
    this.created_at = this.created_at ? new Date(this.created_at) : null
    this.updated_at = this.updated_at ? new Date(this.updated_at) : null
  }

  public get isPending(): boolean {
    return (this.status || '').toLowerCase() === 'pending'
  }

  public get isAccepted(): boolean {
    return (this.status || '').toLowerCase() === 'accepted'
  }

  public get isRevoked(): boolean {
    return (this.status || '').toLowerCase() === 'revoked'
  }
}
